import { render, staticRenderFns } from "./StandardHover.component.vue?vue&type=template&id=d5201b84&scoped=true&"
import script from "./StandardHover.component.vue?vue&type=script&lang=js&"
export * from "./StandardHover.component.vue?vue&type=script&lang=js&"
import style0 from "./StandardHover.component.vue?vue&type=style&index=0&id=d5201b84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5201b84",
  null
  
)

export default component.exports